import { render, staticRenderFns } from "./LoginMagicLink.vue?vue&type=template&id=1f4e5d5a&scoped=true"
import script from "./LoginMagicLink.vue?vue&type=script&lang=js"
export * from "./LoginMagicLink.vue?vue&type=script&lang=js"
import style0 from "./LoginMagicLink.vue?vue&type=style&index=0&id=1f4e5d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e5d5a",
  null
  
)

export default component.exports